
<div class=" flex flex-col justify-center items-center w-full">
  <div class="e-adaptive-demo e-bigger w-full" >
    <div class="e-mobile-layout w-full">
      <div class="e-mobile-content w-full">

          <!-- <div class="p-2 flex-row border-t-grid" style="background-color: #f3f4f6;">

             <button ejs-button class="e-flat e-icons e-search e-search-button my-2" (click)="showFilters($event)"></button> 

            <div @onOff class="flex flex-row py-2" *ngIf="showFilter">
              <div *ngFor="let col of gridColConfig; let i = index">
                <div *ngIf="col.type=='text'" class="px-2.5" >
                  <input #inputEl [id]="col.field" [ngClass]="'e-input e-primary-filtering transform duration-300 '"
                  type="text" (keyup)="created($event)" [placeholder]="col.name" >
                </div>
              </div>
            </div>
          </div> -->

        <ejs-treegrid #Ctablel  [(dataSource)]="parsedData" enableAdaptiveUI="true"  [allowFiltering]="false" allowDeleting=" true"  mode="Batch"
          (actionBegin)="emitActionBegin($event)"  (actionComplete)="emitActionComplete($event)"  [allowSorting]="true" [allowMultiSorting]="true"
          [pageSettings]="pageSettings" (expanding)="expanding($event)" [loadingIndicator]="{indicatorType: 'Shimmer'}"  [enableCollapseAll]="false" expandStateMapping="expanded"   [height]="heightT"   (rowDataBound)="rowDB($event)"  hasChildMapping='isParent' idMapping='rowId' parentIdMapping='parentId'>
          <!-- <ng-template #toolbarTemplate>
            <div class="p-1 pt-2 flex-row border-t-grid" style="background-color: #f3f4f6;">
              <ng-template [ngTemplateOutlet]="template!">

              </ng-template>
              <div class="rounded-lg">

              </div>
            </div>
          </ng-template> -->
          <e-columns>
            <ng-container *ngFor="let col of gridColConfig; let i = index;">

              <e-column *ngIf="col.type == 'img' " field="{{col.field}}" [allowEditing]="false" [headerText]="col.name" [allowSorting]="col.sort || false" [allowFiltering]="col.filter || false"
                [width]="col.width || '100'">
                <ng-template #template let-data>
                  <div class="img-tab-custom">
                    <img id="{{col.field + i.toString()}}" src="{{data[col.field]}}" alt="{{col.name}}"
                      class="{{col.cssClass}}" [ngClass]="{'rounded-lg': col.cssClass == undefined}">
                  </div>
                </ng-template>
              </e-column>

              <e-column *ngIf="col.type == 'button'" field="{{col.field}}"  [allowEditing]="false" [headerText]="col.name" [allowSorting]="col.sort || false" [allowFiltering]="col.filter || false"
                [width]="col.width || '100'">
                <ng-template #template let-data>

                    <button ejs-button class="e-flat" (click)="emitBtnClick(data, col.name.toLowerCase())"
                      [cssClass]="col.cssClass || 'btn--primary-grid text-sky-500'">
                      <!-- <div class="flex"
                        [ngClass]="{'flex-row': getButtonAlign(col) == 'left','flex-row-reverse':  getButtonAlign(col) == 'right'}">
                        <i *ngIf="getButtuonIcon(col) != undefined" style="font-size: 1rem;"
                          [ngClass]="{'grid-icon-color': col.cssClass == undefined}"
                          class="e-icons mx-1   {{getButtuonIcon(col)}}"></i>
                          <span>{{getButtonLabel(col)}}</span></div> -->
                          <!--*ngIf="getButtonLabel(col) != undefined"-->
                    </button>

                </ng-template>
              </e-column>

              <e-column *ngIf="col.type == 'text'" field="{{col.field}}" [allowEditing]="col.edit" [headerText]="col.name" [allowFiltering]="col.filter || true" [allowSorting]="col.sort || true"
                [width]="col.width || '100'" [textAlign]="col.textAlign">
              <!-- <ng-template #template let-data>

                <div class="dtest text-base truncate " title="{{data[col.field]}}">
                  {{data[col.field]}}
                </div>

              </ng-template> -->
              </e-column>

              <e-column *ngIf="col.type == 'switch'" field="{{col.field}}" [headerText]="col.name" [allowFiltering]="col.filter || false" [allowSorting]="col.sort || true"
                [width]="col.width || '100'">
                <ng-template #template let-data>
                  <ejs-switch class="grid-switch-comp" id="{{col.field + i}}" [checked]="data[col.field]"
                    (change)="switchChange($event, data)"></ejs-switch>
                </ng-template>
              </e-column>

              <e-column *ngIf="col.type == 'commands'" [width]="col.width" [commands]="col.commands" [headerText]="col.name"  [allowFiltering]="false" [allowSorting]="false"></e-column>

              <!-- <e-column *ngIf="col.type == 'dropdown'" field="{{col.field}}" [headerText]="col.name" [allowFiltering]="col.filter || false" [allowSorting]="col.sort || true"
                [width]="col.width || '100'">
                <ng-template #template let-data>
                  <ejs-dropdownlist [dataSource]="col.dropdown" [fields]="col.ddO" [value]="data[col.field]"  #dropdownList class="e-input transform duration-300"></ejs-dropdownlist>
                </ng-template>
              </e-column> -->

              <e-column *ngIf="col.type == 'color'" field="{{col.field}}" [headerText]="col.name" [allowFiltering]="col.filter || false" [allowSorting]="col.sort || true"
                [width]="col.width || '100'">
                <ng-template #template let-data>
                  <div class="shadow-md p-4 rounded-lg grid-color-comp" id="{{col.field + i}}"
                    [ngStyle]="{background: data[col.field] || '#eeeeee', width: col.fieldOptions || '100px', height: col.fieldOptions || '100px'}">

                  </div>

                </ng-template>
              </e-column>

              <e-column *ngIf="col.type == 'state'" field="{{col.field}}" [headerText]="col.name" [allowFiltering]="col.filter || false" [allowSorting]="col.sort || true"
                [width]="col.width || '100'">
                <ng-template #template let-data>
                  <div class="shadow-md p-4 rounded-lg e-icons flex flex-row justify-center items-center" style="color:white;" id="{{col.field + i}}"
                  [ngStyle]="{width: getColorWidth(col) || '40px', height: getColorHeight(col) || '40px'}"
                    [ngClass]="{'bg-red-500 e-close': data[col.field] == false,'bg-emerald-500 e-check': data[col.field] == true}">
                  </div>
                </ng-template>
              </e-column>

              <e-column *ngIf="col.type == 'checkbox'" field="{{col.field}}" [headerText]="col.name" [allowFiltering]="col.filter || false" [allowSorting]="col.sort || true"
                [width]="col.width || '100'">
                <ng-template #template let-data>
                  <ejs-checkbox class="grid-chekbox-comp" id="{{col.field + i}}" [checked]="data[col.field]"
                    (change)="checkBoxChange($event, data)"></ejs-checkbox>
                </ng-template>
              </e-column>

              <e-column *ngIf="col.type == 'date'" field="{{col.field}}" [headerText]="col.name" [allowFiltering]="col.filter || true" [allowSorting]="col.sort || true"
              [width]="col.width || '100'"
              >
              <ng-template #template let-data>
                <div class="table-data-format">{{data[col.field] | date}}</div>
              </ng-template>
              </e-column>

              <e-column *ngIf="col.type == 'dateTime'" field="{{col.field}}" [headerText]="col.name" [allowFiltering]="col.filter || true" [allowSorting]="col.sort || true"
              [width]="col.width || '100'"
              >
              <ng-template #template let-data>
                <div class="table-data-format">{{data[col.field] | date: 'dd/MM/YYYY-mm:HH'}}</div>
              </ng-template>
              </e-column>

            </ng-container>
          </e-columns>
        </ejs-treegrid>
      </div>
    </div>
  </div>
